import { GameStatues, GameStatusFlow } from "@grassrootly/api/entities";
import { GetGameNextStatusesPayload } from "@grassrootly/api/gateways";

export const GetGameNextStatuses = async (payload: GetGameNextStatusesPayload): Promise<GameStatues[]> => {
  return GameStatusFlow[payload.game.status];
};
